export default class SmallAssembly {
    constructor(assembly) {
        this.assembly = assembly
        this.loadMoreButton = this.getNextSibling(assembly, '.js-blog-load-more')
        this.numberOfTeasers = this.loadMoreButton.dataset.teaserCount
        this.smallBlogTeasers = assembly.querySelectorAll('.js-blog-teaser')
        this.numberOfVisibleTeasers = parseInt(this.numberOfTeasers)
        this.numberOfTeasersLoadedOnClick = parseInt(this.numberOfTeasers)

        this.collapseTeasers()
        this.addLoadMoreClickListener()
        this.addShowTeasersOnResizeListener()
    }

    /**
     * If there are more teasers than numberOfVisibleTeasers hide the additional teasers and show the load more button
     *
     * @private
     */
    collapseTeasers() {
        const firstHidden = this.smallBlogTeasers[this.numberOfVisibleTeasers]
        if (firstHidden != null) {
            firstHidden.classList.add('js-first-hidden')
            // subtract 1 to prevent a small line from the first hidden teaser to appear with the big teasers in bottom list
            this.assembly.style.height = firstHidden.offsetTop - 1 + 'px'
            this.loadMoreButton.classList.remove('hidden')
        }
    }

    /**
     * Adds an EventListener that handles the behavior of the load more button
     *
     * @private
     */
    addLoadMoreClickListener() {
        // Prevent error when no loadMoreButton is found in markup
        if (this.loadMoreButton == null) {
            return
        }
        this.loadMoreButton.addEventListener('click', () => {
            this.assembly.querySelector('.js-first-hidden').classList.remove('js-first-hidden')
            this.numberOfVisibleTeasers += this.numberOfTeasersLoadedOnClick

            const firstHidden = this.smallBlogTeasers[this.numberOfVisibleTeasers]
            if (firstHidden != null) {
                firstHidden.classList.add('js-first-hidden')
                // subtract 1 to prevent a small line from the first hidden teaser to appear with the big teasers in bottom list
                this.assembly.style.height = firstHidden.offsetTop - 1 + 'px'
            } else {
                const lastTeaser = this.smallBlogTeasers[this.smallBlogTeasers.length - 1]
                this.assembly.style.height = lastTeaser.offsetTop + lastTeaser.offsetHeight + 'px'
                this.loadMoreButton.classList.add('hidden')
            }
        })
    }

    /**
     * @private
     * @param elem
     * @param selector
     * @returns {Element}
     */
    getNextSibling(elem, selector) {
        // Get the next sibling element
        let sibling = elem.nextElementSibling

        // If the sibling matches our selector, use it
        // If not, jump to the next sibling and continue the loop
        while (sibling) {
            if (sibling.matches(selector)) return sibling
            sibling = sibling.nextElementSibling
        }
    }

    /**
     * When an Assembly is hidden due to a breakpoint the teasers can only be collapsed after it comes into view through resizing
     *
     * @private
     */
    addShowTeasersOnResizeListener() {
        const resizeObserver = new ResizeObserver(() => {
            this.collapseTeasers()
        })
        resizeObserver.observe(document.querySelector('body'))
    }
}
